import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UserSettings } from "@/types";

export const userSettingsQueryKey = ["user-settings"] as const;

export function useGetUserSettings() {
  return useQuery({
    queryKey: userSettingsQueryKey,
    queryFn: async () => {
      const path = "user-settings";
      const res = await guacHttpClient.get<
        UserSettings,
        HttpResponse<UserSettings>
      >(path);
      return res.data;
    },
  });
}
